import { render } from "./SourceCode.vue?vue&type=template&id=33b7a01e&scoped=true"
import script from "./SourceCode.vue?vue&type=script&lang=js"
export * from "./SourceCode.vue?vue&type=script&lang=js"

import "./SourceCode.vue?vue&type=style&index=0&id=33b7a01e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b7a01e"]])

export default __exports__